export const S3_PUT_RETRY_DELAYS_MS = [1000, 2000, 4000] as const;

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export type PutToS3Fetch = (
  input: RequestInfo | URL,
  init?: RequestInit
) => Promise<Response>;

export type PutToS3Delay = (ms: number) => Promise<void>;

/**
 * PUT file bytes to S3 presigned URL — no Authorization header.
 * Retries with exponential backoff on network errors or non-2xx responses.
 */
export async function putToS3(
  presignedUrl: string,
  mimeType: string,
  body: Blob | File,
  fetchFn: PutToS3Fetch = fetch,
  delayFn: PutToS3Delay = delay
): Promise<boolean> {
  const maxAttempts = S3_PUT_RETRY_DELAYS_MS.length + 1;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const response = await fetchFn(presignedUrl, {
        method: "PUT",
        headers: { "Content-Type": mimeType },
        body,
      });

      if (response.ok) {
        return true;
      }
    } catch {
      // network error — retry below
    }

    if (attempt < S3_PUT_RETRY_DELAYS_MS.length) {
      await delayFn(S3_PUT_RETRY_DELAYS_MS[attempt]);
    }
  }

  return false;
}
